<template>
  <store-table />
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import storeTableTemp from '../Brand/StoreTable.vue'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1
    }
  },
  mounted () {
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'store-table': storeTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// StoreHistoryTable.vue?52e837b9